import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Foreclosures = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Foreclosures";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
